(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDetailController', SimPhoneDetailController);

    /* Added UIFormAccess, EmployeePhoneSearch
    SimPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SimPhone', 'CloudPBX'];

    function SimPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, SimPhone, CloudPBX) {
    */
    SimPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SimPhone', 'CloudPBX', 'UIFormAccess', 'EmployeePhoneSearch'];

    function SimPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, SimPhone, CloudPBX, UIFormAccess, EmployeePhoneSearch) {
        var vm = this;

        vm.simPhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employeePhones = [];

        vm.employees = EmployeePhoneSearch.query({query: vm.simPhone.number, actual: false}, onSuccess, onError);
        function onSuccess(data, headers) {
            vm.employeePhones = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        var unsubscribe = $rootScope.$on('telestatApp:simPhoneUpdate', function(event, result) {
            vm.simPhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
